import { useFeatureFlag } from '@fs/zion-flags'
import { FLAGS } from '../../../../config/feature/flags'

/**
 * Whether Discovery Center visitors go through the new onboarding flow. discovery_prototypes opts a
 * tester in without discovery_discoveryReact_onboarding.
 *
 * The welcome page and the center session service must agree on this - the onboarding flow mints its
 * sessions on DICE - so both read it here rather than checking the flags themselves.
 */
export default function useCenterOnboarding() {
  const { isOn: onboardingOn } = useFeatureFlag('discovery_discoveryReact_onboarding')
  const { isOn: prototypesOn } = useFeatureFlag(FLAGS.PROTOTYPES)
  return onboardingOn || prototypesOn
}
